/**
 * Global Image Utility & Fallback Handler
 * Handles missing/broken images across all components seamlessly.
 */

export const DEFAULT_PLACEHOLDER = '/img/placeholder.svg';

/**
 * Universal error handler for <img> elements
 * Prevents broken image icons and clears loading skeleton overlays.
 * Falls back to raw original source before showing the placeholder.
 */
export const handleImageError = (e, setLoadedCallback = null) => {
  if (!e || !e.target) return;

  const target = e.target;

  // 1. If CDN URL failed and original raw source is available, fallback to original once
  const originalSrc = target.dataset?.originalSrc;
  if (originalSrc && target.src !== originalSrc && target.dataset.triedOriginal !== 'true') {
    target.dataset.triedOriginal = 'true';
    target.src = originalSrc;
    return;
  }

  // 2. Prevent infinite retry loops
  if (target.dataset.hasFailed === 'true') {
    return;
  }

  target.dataset.hasFailed = 'true';
  target.src = DEFAULT_PLACEHOLDER;
  target.classList.remove('loading');
  target.classList.add('loaded');

  if (setLoadedCallback && typeof setLoadedCallback === 'function') {
    setLoadedCallback(true);
  }
};

export default handleImageError;

